<template>
  <!-- 申请成功 -->
  <div class="applySuccess">
     <mt-header title="申请成功">
      <mt-button slot="right" @click="project">完成</mt-button>
    </mt-header>
    <div class="content">
      <h1><icon name='check-circle'></icon>申请成功</h1>
      <p>申请意向发送成功!项目方如果对你感兴趣，会主动和您联系，届时请及时查看并回复消息。</p>
    </div>
    <div class="btns">
      <button type="button" @click="project">查看我的申请</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applySuccess',
  data () {
    return {
      projectid: ''
    }
  },
  mounted () {
  },
  methods: {
    project () {
      let _this = this
      _this.projectid = this.$route.query.projectid
      console.log(_this.projectid)
      this.STATE.state.myProjectDetailId = _this.projectid
      _this.$router.push({name: 'myProjectDetail', params: { projectId: _this.projectid }})
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 40%;
}
.content h1{
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}
.content h1 .fa-icon{
  color: #108ee9;
  transform: scale(1.5);
  margin-right:10px;
}
.content p{
  font-size: 14px;
  text-indent: 24px;
  width: 80%;
  margin: 24px auto 0;
}
.btns{
  margin-top: 20%;
  text-align: center;
}
.btns button{
  width: 90%;
  font-size: 14px;
  color: #fff;
  background-color: #108ee9;
  height: 38px;
  border: none;
  outline:none;
  border-radius:20px;
  -webkit-border-radius:20px;
  -moz-border-radius:20px;
}
</style>


// WEBPACK FOOTER //
// applySuccess.vue?080dc38a